module.exports = __webpack_public_path__ + "img/orange_108.990db852.png";